import linkifyHtml from 'linkify-html';

const linkify = (el, /*binding*/) => {
  el.innerHTML = linkifyHtml(el.innerHTML, {
    target: '_blank'
  });
};

export default linkify;
